<template>
  <div class="dropdown">
    <button
      class="dropdown-toggle"
      :class="{ active: isOpen }"
      @click="toggleDropdown"
      :aria-expanded="isOpen"
      aria-haspopup="listbox"
      aria-label="Select model"
    >
      {{ selectedChatbot?.name || "Select a Bot" }}
      <svg class="arrow" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <polyline points="6 9 12 15 18 9"></polyline>
      </svg>
    </button>
    <div class="dropdown-menu" v-if="isOpen" role="listbox">
      <!-- Use v-for to dynamically render chatbot items -->
      <div
        class="dropdown-item"
        v-for="chatbot in chatbots"
        :key="chatbot.id"
        role="option"
        :aria-selected="selectedChatbot?.id === chatbot.id"
        @click="selectChatbot(chatbot)">
        {{ chatbot.name }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    chatbots: {
      type: Array,
      required: true
    },
    selectedChatbot: {
      type: Object,   // ✅ supports { id, name } and more
      required: true
    }
  },
  data() {
    return {
      isOpen: false,
      // selectedChatbot: null
    };
  },
  watch: {
    // Watch for changes in the chatbots prop and restore from localStorage
    chatbots: {
      immediate: true, // This will trigger the watcher when the component is created
      handler(newChatbots) {
        if (newChatbots && newChatbots.length > 0) {
          // Load selected chatbot from localStorage
          const storedChatbot = localStorage.getItem('selectedChatbot');
          if (storedChatbot) {
            try {
              const chatbot = JSON.parse(storedChatbot);
              // Verify the chatbot still exists in the available chatbots
              const exists = newChatbots.some(c => c.id === chatbot.id);
              if (exists) {
                this.$emit('select-chatbot', chatbot);
              }
            } catch (error) {
              console.error('Error parsing stored chatbot:', error);
            }
          }
        }
      }
    }
  },
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen;
      console.log('Dropdown is now', this.isOpen);
      if (this.isOpen) {
        this.$nextTick(() => {
          document.addEventListener('click', this._closeDropdownOnOutsideClick, true);
        });
      } else {
        document.removeEventListener('click', this._closeDropdownOnOutsideClick, true);
      }
    },
    _closeDropdownOnOutsideClick(event) {
      if (!this.$el.contains(event.target)) {
        this.isOpen = false;
        document.removeEventListener('click', this._closeDropdownOnOutsideClick, true);
      }
    },
    selectChatbot(chatbot) {
      // this.selectedChatbot = chatbot;
      this.isOpen = false;
      document.removeEventListener('click', this._closeDropdownOnOutsideClick, true);

      // Save to localStorage
      localStorage.setItem('selectedChatbot', JSON.stringify(chatbot));

      this.$emit('select-chatbot', chatbot);
    }
  },
  beforeUnmount() {
    document.removeEventListener('click', this._closeDropdownOnOutsideClick, true);
  }
};
</script>

<style scoped>
.dropdown {
  display: inline-block;
  position: relative;
}

.dropdown-toggle {
  background-color: var(--bg-surface);
  color: var(--text-primary);
  padding: var(--space-xs) var(--space-md);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-pill);
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: var(--space-xs);
  font-family: var(--font-sans);
  font-size: var(--text-sm);
  font-weight: var(--font-medium);
  transition: var(--transition-colors), var(--transition-shadow);
  white-space: nowrap;
}

.dropdown-toggle:hover {
  background-color: var(--bg-surface-hover);
  border-color: var(--border-primary);
  box-shadow: var(--shadow-sm);
}

.dropdown-toggle.active {
  background-color: var(--bg-surface-hover);
  border-color: var(--border-primary);
  box-shadow: var(--shadow-card);
}

.arrow {
  margin-left: var(--space-xs);
  width: 14px;
  height: 14px;
  opacity: 0.5;
  transition: transform var(--duration-base) var(--ease-default);
}

.dropdown-toggle.active .arrow {
  transform: rotate(180deg);
}

.dropdown-menu {
  position: absolute;
  background-color: var(--bg-surface);
  min-width: 180px;
  box-shadow: var(--shadow-float);
  border: 1px solid var(--border-subtle);
  z-index: 10;
  border-radius: var(--radius-lg);
  overflow: hidden;
  top: calc(100% + var(--space-xs));
  left: 0;
  font-family: var(--font-sans);
  animation: fadeInScale var(--duration-base) var(--ease-out);
}

.dropdown-item {
  padding: var(--space-md) var(--space-lg);
  cursor: pointer;
  font-size: var(--text-sm);
  color: var(--text-primary);
  transition: var(--transition-colors);
}

.dropdown-item:hover {
  background-color: var(--bg-surface-hover);
}
</style>
